<template>
	<div>
  <a
  v-show="isVisible"
  class="scroll-call-btn"
  href="tel:+19808905255"
  aria-label="Call us"
>
  <font-awesome-icon icon="phone-volume" />
</a>
	</div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    }
   //  scrollToTop() {
   //    window.scrollTo({
   //      top: 0,
   //      behavior: "smooth"
   //    });
   //  }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>

<style scoped>
.scroll-call-btn {
  position: fixed;
  bottom: 28px;
  right: 28px;

  width: 56px;
  height: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(65, 77, 67, 1);
  color: #bcbbbb;

  border-radius: 50%;
  border: none;

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  cursor: pointer;

  animation: callPulse 2.6s ease-in-out infinite;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;

  z-index: 1000;
}

/* Icon */
.scroll-call-btn svg {
  width: 22px;
  height: 22px;
}

/* Hover stops pulse */
.scroll-call-btn:hover {
  animation-play-state: paused;
  background-color: rgb(74, 79, 75);
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.3);
}

/* Active */
.scroll-call-btn:active {
  transform: scale(0.96);
}

/* Micro-pulse keyframes */
@keyframes callPulse {
  0% {
    transform: scale(1);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 10px 26px rgba(74, 79, 75, 0.45);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  }
}

/* Mobile optimization */
@media (max-width: 768px) {
  .scroll-call-btn {
    width: 52px;
    height: 52px;
  }

  /* .scroll-call-btn svg {
    font-size: 20px;
  } */
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .scroll-call-btn {
    animation: none;
  }
}
</style>